import { useState, useCallback } from 'react';
import { validateAddressInServiceArea } from '../api/publicBookingApi';

const useAddressValidation = (slug) => {
  const [validationResult, setValidationResult] = useState(null);
  const [isValidating, setIsValidating] = useState(false);
  const [validationError, setValidationError] = useState(null);

  const validateAddress = useCallback(async (placeId) => {
    if (!placeId || !slug) {
      setValidationResult(null);
      setValidationError(null);
      return;
    }

    setIsValidating(true);
    setValidationError(null);

    try {
      const result = await validateAddressInServiceArea(slug, placeId);
      setValidationResult(result);
    } catch (err) {
      setValidationError(err.message);
      setValidationResult(null);
    } finally {
      setIsValidating(false);
    }
  }, [slug]);

  const resetValidation = useCallback(() => {
    setValidationResult(null);
    setValidationError(null);
    setIsValidating(false);
  }, []);

  return {
    validationResult,
    isValidating,
    validationError,
    validateAddress,
    resetValidation
  };
};

export default useAddressValidation;